import { useContext, useEffect } from 'react';
import { Context } from '../../../context/context';
import { IState } from '../../../context/stateModels';
import styles from './SessionExpirationView.module.scss';
import { LogoNormal } from '@aidexa/open-ds';
import { useRouter } from 'next/router';
import { SessionEspirationViewProps } from './types';
import { setSessionExpiredDispatch, setSessionExpiredStorage } from '@utils/setSessionExpired';

const SessionEspirationView = ({
  sessionExpiring,
  sessionExpired,
  missingSeconds,
  subscription
}: SessionEspirationViewProps) => {
  const { state, dispatch } = useContext<IState>(Context);
  const router = useRouter();

  const handleClickRestoreSession = async () => {
    const { coreInformation } = state;

    setSessionExpiredStorage(false);
    setSessionExpiredDispatch(dispatch, false);

    if (router.asPath.includes('contatti') || router.asPath.includes('contacs')) {
      window.location.reload();
      return;
    }

    const queryParams = `?bpmId=${coreInformation.bpmId}${coreInformation.isConto ? '&isConto=true' : ''}`;
    router.push(`../contatti/${queryParams}`);
  };

  useEffect(() => {
    dispatch({ type: 'TOTAL_HEIGHT' });
  }, []);

  return (
    <div className={`error-content ${styles.content}`}>
      <div className={`${styles.logoWrapper}`}>
        <LogoNormal />
      </div>
      <div className={styles.container}>
        {sessionExpiring && !sessionExpired && (
          <div>
            <div className={styles.title}>
              {subscription.titlePageSessionExpiring} {missingSeconds} {'secondi'}
            </div>
            <div className={styles.description}>
              <span dangerouslySetInnerHTML={{ __html: subscription.descriptionPageSessionExpiring }} />
            </div>
            <div className={styles.btnsContainer}>
              <button data-testid="resumeSessionCTA" onClick={() => window.location.reload()} role="click-refresh">
                {subscription.ctaSessionExpiring}
              </button>
            </div>
          </div>
        )}
        {sessionExpired && (
          <div>
            <div className={styles.title}>{subscription.titlePageSessionExpired}</div>
            <div className={styles.description}>
              <span dangerouslySetInnerHTML={{ __html: subscription.descriptionPageSessionExpered }} />
            </div>
            {subscription.ctaSessionExpired && (
              <div className={styles.btnsContainer}>
                <button onClick={handleClickRestoreSession} role="click-back-contacts">
                  {subscription.ctaSessionExpired}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SessionEspirationView;
